import { supabase, SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from "@/integrations/supabase/client";
import { authRedirectOrigin } from "@/utils/passwordSecurity";

export async function startGoogleSignIn() {
  // Checking the public provider setting prevents a redirect to Supabase's raw
  // error page while OAuth setup is pending. This key is public, not a secret.
  const response = await fetch(`${SUPABASE_URL}/auth/v1/settings`, {
    headers: { apikey: SUPABASE_PUBLISHABLE_KEY }, signal: AbortSignal.timeout(10_000),
  });
  if (!response.ok || (await response.json()).external?.google !== true) throw new Error("Google sign-in is not enabled");
  const { error } = await supabase.auth.signInWithOAuth({
    provider: "google",
    options: { redirectTo: authRedirectOrigin(window.location.origin), queryParams: { prompt: "select_account" } },
  });
  if (error) throw error;
}
